import ProductDetailsView from "./ProductDetailsView";

import "./ProductDetailsView.scss";

export * from "./ProductDetailsView";

export { ProductDetailsView };
